var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 203.14,
    viewBox: "0 0 250 203.14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1da1f2;}.cls-2{fill:#fff;}.cls-3{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter_Logo_White-on-Blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m78.62 203.14c94.34 0 145.94-78.16 145.94-145.94 0-2.22 0-4.43-0.15-6.63a104.36 104.36 0 0 0 25.59-26.55 102.38 102.38 0 0 1-29.46 8.07 51.47 51.47 0 0 0 22.55-28.37 102.79 102.79 0 0 1-32.57 12.45 51.34 51.34 0 0 0-87.41 46.78 145.62 145.62 0 0 1-105.71-53.59 51.33 51.33 0 0 0 15.88 68.47 50.91 50.91 0 0 1-23.28-6.42v0.65a51.31 51.31 0 0 0 41.15 50.28 51.21 51.21 0 0 1-23.16 0.88 51.35 51.35 0 0 0 47.92 35.62 102.92 102.92 0 0 1-63.7 22 104.41 104.41 0 0 1-12.21-0.74 145.21 145.21 0 0 0 78.62 23"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -456.74,
    y: -80.811,
    width: 400,
    height: 400
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.f678a6f487a32a35905c3dbdf3adb029.svg";
export { ForwardRef as ReactComponent };